
import { motion } from "framer-motion";
import { DietaryRestriction } from "@/types/dietary";

interface DietaryOptionProps {
  alternative: DietaryRestriction['alternatives'][0];
  index: number;
}

export const DietaryOption = ({ alternative, index }: DietaryOptionProps) => {
  return (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      className="bg-white/80 p-3 rounded-lg shadow-sm"
    >
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="line-through text-gray-500">{alternative.original}</span>
        <span className="text-purple-600">➜</span>
        <span className="font-medium text-purple-700">{alternative.replacement}</span>
      </div>
      <p className="text-xs text-gray-600 mt-1 italic">
        <span className="text-purple-600">Tip:</span> {alternative.note}
      </p>
    </motion.div>
  );
};
